import { Modal } from "../../ui/Modal/Modal"
import logoBlack from '../../assets/img/logo-black.png'
import { FC } from "react"
import { FormModalProps } from "../Header/Header"
import { useDispatch } from 'react-redux';
import { toogleAuth } from '../../redux/reducers/authSlice';

export const SuccessModal:FC<FormModalProps> = ({ logRegModal, setLogRegModal, successModal, setSuccessModal }) => {

    const dispatch = useDispatch()

    const handeSuccess = () => {
        setSuccessModal(!successModal)
        setLogRegModal(!logRegModal)
        dispatch(toogleAuth())
    }

    return (
        <Modal active={successModal} setActive={setSuccessModal}>
            <div className='form-container'>
                <img className='form-container__logo' src={logoBlack} alt="logoBlack" />
                <h2 className='form-container__title'>Регистрация завершена</h2>
                <p className='form-container__text'> Используйте вашу электронную почту для входа</p>
                <button className='btn btn-blue' onClick={handeSuccess}>Войти</button>
            </div>
        </Modal>

    )


}